import { arrayGetSet, createAccessors, isFlagSet } from 'z3k-parser/lib';
export var MQTTTopic;
(function (MQTTTopic) {
    let Params;
    (function (Params) {
        Params[Params["PUBLICATION_TOPIC"] = 1] = "PUBLICATION_TOPIC";
        Params[Params["SUBSCRIPTION_TOPIC"] = 2] = "SUBSCRIPTION_TOPIC";
        Params[Params["TYPE_PARAMS_1"] = 4] = "TYPE_PARAMS_1";
        Params[Params["TYPE_PARAMS_2"] = 8] = "TYPE_PARAMS_2";
        Params[Params["RETAIN"] = 16] = "RETAIN";
        Params[Params["HOME_ASSISTANT"] = 32] = "HOME_ASSISTANT";
    })(Params = MQTTTopic.Params || (MQTTTopic.Params = {}));
    function isPublicationTopic(item) {
        return isFlagSet(item, Params.PUBLICATION_TOPIC);
    }
    MQTTTopic.isPublicationTopic = isPublicationTopic;
    function isHomeAssistant(item) {
        return isFlagSet(item, Params.HOME_ASSISTANT);
    }
    MQTTTopic.isHomeAssistant = isHomeAssistant;
    function isTopicSelectTypeObject(item) {
        return item.type_object !== 255;
    }
    MQTTTopic.isTopicSelectTypeObject = isTopicSelectTypeObject;
    MQTTTopic.get = createAccessors(arrayGetSet('mqtt_topics'), {
        name: 'Устройство Topic',
        type_object: 255, //255-для варианта когда выбраны link-list or Подписка (setting_register: 1)
        link_list: [],
        setting_register: 1 << 1,
        period: 10000,
        qos: 0,
    });
})(MQTTTopic || (MQTTTopic = {}));
